import React from 'react'

import Loader from '../Loader'
import { AutoRow } from '../Row'

export function renderPendingContent(
  pendingLabel: React.ReactNode | undefined,
  children: React.ReactNode,
  loaderStroke?: string,
): React.ReactNode {
  return (
    <AutoRow gap="6px" justify="center">
      <Loader stroke={loaderStroke ?? 'white'} />
      {pendingLabel ?? children}
    </AutoRow>
  )
}
